module.exports = __webpack_public_path__ + "static/media/img-porto-2.06df809b.jpg";